'use client';

import styles from './RepairRequestBoutiqueSummary.module.scss';

/** Display-only boutique fields — accepts Valtio snapshot hits without StoreHit's index signature. */
export interface RepairRequestBoutiqueSummaryData {
  name: string;
  street: string;
  street2?: string;
  postal_code?: string;
  city: string;
  region?: string;
}

interface RepairRequestBoutiqueSummaryProps {
  boutique: RepairRequestBoutiqueSummaryData;
}

export function RepairRequestBoutiqueSummary({
  boutique,
}: Readonly<RepairRequestBoutiqueSummaryProps>) {
  return (
    <address className={styles.address} data-testid="review-boutique-summary">
      <p className={styles.name}>{boutique.name}</p>
      <p>{boutique.street}</p>
      {boutique.street2 ? <p>{boutique.street2}</p> : null}
      <p>
        {boutique.postal_code ? `${boutique.postal_code} ` : ''}
        {boutique.city}
        {boutique.region ? `, ${boutique.region}` : ''}
      </p>
    </address>
  );
}
